export default __webpack_public_path__ + "static/Igloo-14c811c1e7c90281f954e6bbd14b2225.svg";